import cubejs from '@cubejs-client/core';
import http from './http';

const API_URL = `${import.meta.env.VITE_APP_CUBEJS_API}/cubejs/v1`;
const CUBEJS_TOKEN = window.localStorage.getItem('cubejs_token');
const cubejsApi = cubejs(CUBEJS_TOKEN, {
  apiUrl: API_URL,
});

export default cubejsApi;

export const getCubejsToken = async () => {
  const response = await http.get(`/transactions/cubejs`);
  const CUBEJS_TOKEN = response?.data?.data;
  localStorage.setItem('cubejs_token', CUBEJS_TOKEN);
  return CUBEJS_TOKEN;
};

let isRefreshing = false;
let refreshPromise = null;
export const refreshTokenIfNeeded = async () => {
  if (isRefreshing) {
    return refreshPromise;
  }
  isRefreshing = true;
  refreshPromise = (async () => {
    try {
      const token = await getCubejsToken();
      return token;
    } finally {
      isRefreshing = false;
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};